.formContainer {
  display: grid;
  grid-template-columns: 350px 1fr;
  gap: var(--space-m) var(--space-xl);
  grid-template-areas: "form sidebar";
}

.form {
  grid-area: form;
}

.components {
  grid-area: sidebar;
}

.buttonsContainer {
  margin-top: var(--space-l);
  display: flex;
  justify-content: flex-end;
}
